import React, { useState } from "react";
import * as styles from "./DropDownRefact.module.scss";
import { Link } from "gatsby";
import arrowBlack from "../../../icons/arrows/downArrowBlack.svg";
import DestacadosMobile from "../DestacadosMobile/DestacadosMobile";

const formatSubCategoryName = (name) => {
  return name.toLowerCase().replace(/\s+/g, "-");
};

const DropDownRefact = ({ categories }) => {
  const [openCategories, setOpenCategories] = useState({});
  const [isMainOpen, setIsMainOpen] = useState(false);

  // Construir árbol de categorías
  const buildCategoryTree = (categories) => {
    const categoryMap = {};
    const tree = [];

    if (Array.isArray(categories)) {
      categories.forEach((cat) => {
        categoryMap[cat.id] = { ...cat, children: [] };
      });
    
      categories.forEach((cat) => {
        if (cat.patternCategory && categoryMap[cat.patternCategory]) {
          categoryMap[cat.patternCategory].children.push(categoryMap[cat.id]);
        } else {
          tree.push(categoryMap[cat.id]);
        }
      });
    }    

    return tree;
  };

  const categoryTree = buildCategoryTree(categories);

  // Alternar visibilidad de categorías
  const toggleDropdown = (categoryId) => {
    setOpenCategories((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };

  // Renderizar categorías y subcategorías
  const renderCategories = (categories, isSubCategory = false) => {
    return (
      <ul className={styles.category_list}>
        {categories.map((category, index) => {
          const isLastItem = index === categories.length - 1;
          return (
            <li
              key={category.id}
              className={`${styles.category_item} ${
                isSubCategory && isLastItem ? styles.last_item : ""
              }`}
            >
              {category.children.length > 0 ? (
                <div
                  className={styles.category_parent}
                  onClick={() => toggleDropdown(category.id)}
                >
                  <p className={styles.dropdown_title}>{category.name}</p>
                  <img
                    src={arrowBlack}
                    alt="Toggle"
                    className={`${styles.arrow_icon} ${
                      openCategories[category.id] ? styles.open : ""
                    }`}
                  />
                </div>
              ) : (
                <Link
                  to={`/productos/${formatSubCategoryName(category.name)}/`}
                  className={styles.category_link}
                >
                  {category.name}
                </Link>
              )}
              {category.children.length > 0 && openCategories[category.id] && (
                <div className={styles.category_dropdown}>
                  {renderCategories(category.children, true)}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className={styles.category_container}>
      {/* Dropdown superior "Productos" */}
      <div
        className={styles.main_dropdown}
        onClick={() => setIsMainOpen(!isMainOpen)}
      >
        <p className={styles.dropdown_title}>Productos</p>
        <img
          src={arrowBlack}
          alt="Toggle"
          className={`${styles.arrow_icon} ${isMainOpen ? styles.open : ""}`}
        />
      </div>

      {/* Contenido desplegable del dropdown */}
      {isMainOpen && (
        <div className={styles.main_container}>
          {renderCategories(categoryTree)}
          <div className={styles.destacados_container}>
            <DestacadosMobile />
          </div>
        </div>
      )}
    </div>
  );
};

export default DropDownRefact;
